import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { WorkItem, WorkItemUI } from '../../models/work-item';



export class WorkItemCellComponent {
    constructor() {
    }
     col: string;
     row: object;
     context: string = 'list';
     readonly onDetailPreview = new EventEmitter();
     readonly onQuickPreview = new EventEmitter();
     readonly clickLabel = new EventEmitter();
     readonly onChildExploration = new EventEmitter();
     readonly onDelete = new EventEmitter();


    onDetail(Event: MouseEvent, id: string) {
      this.onDetailPreview.emit(id);
    }

    labelClick(event) {
      this.clickLabel.emit(event);
    }

    onPreview(Event: MouseEvent, workItem: WorkItemUI) {
      this.onQuickPreview.emit(workItem);
    }

    onExploration(workItem: WorkItemUI) {
      if (workItem.hasChildren) {
        this.onChildExploration.emit(workItem);
      }
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  encapsulation: ViewEncapsulation.None,
  selector: 'work-item-cell',
  templateUrl: './work-item-cell.component.html',
  styleUrls: ['./work-item-cell.component.less']
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'col': [{ type: Input },],
'row': [{ type: Input },],
'context': [{ type: Input },],
'onDetailPreview': [{ type: Output },],
'onQuickPreview': [{ type: Output },],
'clickLabel': [{ type: Output },],
'onChildExploration': [{ type: Output },],
'onDelete': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
